import { Box } from '@chakra-ui/react';

interface FactorBarProps {
  label: string;
  valueClassName?: string;
  className?: string;
}

export function FactorBar({ label, valueClassName, className }: FactorBarProps) {
  const hasValueClass = Boolean(valueClassName);
  return (
    <Box
      borderRadius="lg"
      borderWidth="1px"
      borderColor="border.subtle"
      bg="surface.control"
      p="3"
      className={className}
    >
      <Box
        fontSize="xs"
        fontWeight="semibold"
        textTransform="uppercase"
        letterSpacing="wide"
        color="text.muted"
      >
        {label}
      </Box>
      <Box
        mt="2"
        h="1.5"
        w="full"
        overflow="hidden"
        borderRadius="full"
        bg="white/0.04"
      >
        <Box
          h="full"
          w="full"
          borderRadius="full"
          bg={hasValueClass ? undefined : 'signal.blue/70'}
          className={valueClassName}
        />
      </Box>
    </Box>
  );
}